export default __webpack_public_path__ + "static/media/Home_Texto.d27e426d.png";